import { render } from "./googlepay.vue?vue&type=template&id=2e72828e"
import script from "./googlepay.vue?vue&type=script&lang=js"
export * from "./googlepay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__